let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Wy9u")).then(() => parcelRequire('i2i8e'));